import { urlAdd, urlRemove } from '../../../../Utils/URL'
import { getStartEndDateFromWeekFilter } from '../../../../Utils/Table'
import {
  browserSafeNewDate,
  dropTimeZoneFromDate,
  get24HourTime,
  getShortWeekDay,
  getWeekNumber,
  toLocaleNonAmericanDateString,
} from '../../../../shared/libraries/utils/date'

const setUrl = (label, value) => {
  if (value && value !== 'All') {
    urlAdd(label, value)
  } else {
    urlRemove(label)
  }
}

const calculateTimeOfDay = mission => {
  var localDateTimeStr = dropTimeZoneFromDate(mission.dateTime)
  var localTime = localDateTimeStr.slice('yyyy-mm-ddT'.length)
  if (localTime < mission.cityPlan.city.lunchCheckInTime) return 'MORNING'
  if (localTime < mission.cityPlan.city.afternoonCheckInTime) return 'LUNCH'
  return 'AFTERNOON'
}

const getMetrics = node => {
  const getMetric = value => {
    if (!value) {
      return ' - '
    }
    const currentMetric = node.metricResults.nodes.find(
      r => r.metric.id === value.id,
    )
    return `${value.name}: ${currentMetric ? currentMetric.value : 0}`
  }
  const metric1 = getMetric(node.cityPlan.campaign.metrics.nodes[0])
  const metric2 = getMetric(node.cityPlan.campaign.metrics.nodes[1])
  return [metric1, metric2]
}

const formatRows = data => ({
  totalCount: data.city.missions.totalCount,
  nodes: data.city.missions.edges.map(({ node }) => {
    const localDateStr = dropTimeZoneFromDate(node.dateTime)
    const localDate = browserSafeNewDate(localDateStr)

    const metrics = getMetrics(node)
    return {
      id: node.id,
      clientName: node.cityPlan.campaign.client.name,
      campaignName: node.campaign.name,
      week: 'W' + getWeekNumber(localDate),
      date: toLocaleNonAmericanDateString(localDate),
      time: get24HourTime(localDate),
      timeOfDay: calculateTimeOfDay(node),
      dayOfWeek: getShortWeekDay(localDate.getDay()),
      canBeSpied: node.canBeSpied,
      location: node.location ? node.location.name : ' - ',
      brandAmbassador: node.user
        ? node.user.firstName + ' ' + node.user.lastName
        : '',
      flyerCode: node.flyerCodeV2 ? node.flyerCodeV2.code : ' - ',
      tag: node.flyerCodeV2 ? node.flyerCodeV2.tag : ' - ',
      flyersDistributed: node.totalFlyersDistributed,
      scans: node.amountScans,
      metric1: metrics[0] ? metrics[0] : ' - ',
      metric2: metrics[1] ? metrics[1] : ' - ',
      status: node.status,
      rating: node.rating,
      spy:
        node.spyInformation && node.spyInformation.spy
          ? `${node.spyInformation.spy.firstName} ${
              node.spyInformation.spy.lastName
            }`
          : false,
      isReported:
        node.spyInformation &&
        node.spyInformation.spyDetails &&
        node.spyInformation.spyDetails.reportReason,
      isSpied:
        node.spyInformation &&
        node.spyInformation.spyDetails &&
        node.spyInformation.spyDetails.checkInTime,
      shiftId:
        node.spyInformation &&
        node.spyInformation.shift &&
        node.spyInformation.shift.id,
    }
  }),
})

const switchOrderBy = value => {
  switch (value) {
    case 'date':
      return 'dateTime'
    case 'week':
      return 'dateTime'
    case 'time':
      return 'dateTime'
    case 'brandAmbassador':
      return 'user'
    default:
      return value
  }
}

const switchLabelToId = value => {
  switch (value) {
    case 'Client':
      return 'clientId'
    case 'Week':
      return 'week'
    case 'Location':
      return 'locationId'
    case 'Campaign':
      return 'campaignId'
    case 'Status':
      return 'status'
    case 'Time of day':
      return 'timeOfDay'
    case 'Day of week':
      return 'dayOfTheWeek'
    case 'Reported':
      return 'reported'
    default:
      return null
  }
}

const checkValue = value => (value === 'All' ? null : value)

const getUpdatedQueryAndLabels = (prev, arrValues) => {
  const newVal = prev

  arrValues.forEach(value => {
    const { label, labelValue, queryValue } = value
    const newLabel = switchLabelToId(label)
    if (newLabel === 'week') {
      const { startDate, endDate } = getStartEndDateFromWeekFilter(queryValue)

      newVal.labels = { ...newVal.labels, [label]: labelValue }
      newVal.query = { ...newVal.query, startDate, endDate }
    } else if (newLabel === 'status') {
      newVal.labels = { ...newVal.labels, [label]: labelValue }
      newVal.query = {
        ...newVal.query,
        statusAndBelow: checkValue(queryValue),
        statusAndAbove: checkValue(queryValue),
      }
    } else {
      newVal.labels = { ...newVal.labels, [label]: labelValue }
      newVal.query = {
        ...newVal.query,
        [newLabel]: checkValue(queryValue),
      }
    }
  })

  return newVal
}

const getUpdatedMappedFilters = ({
  prev,
  updatedValues = [],
  date = {},
  isOnlyOne = false,
}) => {
  const newData = [...prev]
  return newData.reduce((acc, item) => {
    const value = updatedValues.find(value => value.label === item.data.label)
    if (value) {
      const { dateWeekNumber, dateYearNumber } = date
      if (item.data.label === 'Week' && dateWeekNumber && dateYearNumber) {
        const option = item.data.options.find(
          item =>
            item.value.weekNumber === dateWeekNumber &&
            item.value.year === dateYearNumber,
        )
        acc.push({
          ...item,
          data: { ...item.data, selectedValue: option.value },
        })
      } else {
        acc.push({
          ...item,
          data: { ...item.data, selectedValue: value.queryValue },
        })
      }
    } else {
      acc.push({
        ...item,
        data: {
          ...item.data,
          selectedValue: isOnlyOne ? item.data.selectedValue : 'All',
        },
      })
    }
    return acc
  }, [])
}

const onClickRow = (event, id) => {
  window.open(`/dashboard/mission/${id}`, '_blank')
}

const getTitle = ({ numSelected, neededCount }) => {
  if (!neededCount) {
    return 'If you want to work with Spy, please define Spy Settings in city settings.'
  }

  if (!numSelected) {
    return 'Do you want assign create Spy Shift, please select Spys in column SPY'
  }

  if (numSelected && neededCount) {
    return `You have selected ${numSelected} from ${neededCount} missions, assign Spy to create Spy Shift`
  }
}

export {
  setUrl,
  calculateTimeOfDay,
  switchLabelToId,
  switchOrderBy,
  formatRows,
  checkValue,
  getUpdatedQueryAndLabels,
  getUpdatedMappedFilters,
  onClickRow,
  getTitle,
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/MasterSchedule/utils.js